import { render, staticRenderFns } from "./MetricsBreakdownCard.vue?vue&type=template&id=6921af09&scoped=true&"
import script from "./MetricsBreakdownCard.vue?vue&type=script&lang=js&"
export * from "./MetricsBreakdownCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricsBreakdownCard.vue?vue&type=style&index=0&id=6921af09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6921af09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCol,VRow,VSwitch})
